import L2Category from './L2Category';
import { L2CategoryContainer } from './styled';

export default function L2CategoryScroll(props) {
  const { subCategoriesData, categoryId } = props;
  let showL2 = false;
  subCategoriesData?.map((element) => {
    if (element?.subCategories?.length) {
      showL2 = true;
    }
  });
  return (
    <>
      {subCategoriesData?.length > 0 && showL2 && (
        <L2CategoryContainer>
          {subCategoriesData?.map((element, index) => {
            return (
              <L2Category
                element={element}
                index={index}
                categoryId={categoryId}
                key={index}
              />
            );
          })}
        </L2CategoryContainer>
      )}
    </>
  );
}
